var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 5,
    viewBox: "0 0 3 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87629 4.89616C2.91549 4.86296 2.9466 4.82346 2.96784 4.77995C2.98907 4.73643 3 4.68976 3 4.64261C3 4.59547 2.98907 4.5488 2.96784 4.50528C2.9466 4.46176 2.91549 4.42227 2.87629 4.38907L0.960816 2.75354C0.921616 2.72035 0.890503 2.68085 0.86927 2.63733C0.848037 2.59382 0.837105 2.54714 0.837105 2.5C0.837105 2.45286 0.848037 2.40618 0.86927 2.36267C0.890503 2.31915 0.921616 2.27965 0.960815 2.24646L2.87629 0.610928C2.91549 0.577731 2.9466 0.538235 2.96784 0.494719C2.98907 0.451202 3 0.404527 3 0.357385C3 0.310244 2.98907 0.263568 2.96784 0.220052C2.9466 0.176536 2.91549 0.13704 2.87629 0.103843C2.79793 0.0373321 2.69193 4.03986e-08 2.58144 5.48875e-08C2.47095 6.93764e-08 2.36495 0.0373321 2.28659 0.103843L0.366935 1.74294C0.131975 1.94381 5.21882e-08 2.2161 8.94168e-08 2.5C1.26645e-07 2.7839 0.131975 3.05619 0.366935 3.25706L2.28659 4.89616C2.36495 4.96267 2.47095 5 2.58144 5C2.69193 5 2.79793 4.96267 2.87629 4.89616Z",
    fill: "#99A7C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.24c66f279f289b3d04c936862b90e9d1.svg";
export { ForwardRef as ReactComponent };